// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultTheme__sidebar-link___2j3Ea {
  list-style-type: none;
  margin: 10px 0;
  padding: 0 20px;
  position: relative;
}

.DefaultTheme__icon___3DO_l {
  fill: currentColor;
  margin-right: 5px;
}

.DefaultTheme__anchor___1Xu1v {
  --_apc-sidebar-text-decoration: var(--_apc-sidebar-text-decoration-lume, none);

  align-items: center;
  color: var(--_apc-sidebar-text-color, var(--steel4));
  cursor: pointer;
  display: flex;
  -webkit-text-decoration: var(--_apc-sidebar-text-decoration);
          text-decoration: var(--_apc-sidebar-text-decoration);
}

.DefaultTheme__anchor___1Xu1v:hover {
    --_apc-sidebar-hover-font-weight: var(--_apc-sidebar-hover-font-weight-lume, 400);

    font-weight: var(--_apc-sidebar-hover-font-weight);
  }

.DefaultTheme__anchor___1Xu1v:active,
  .DefaultTheme__anchor___1Xu1v.DefaultTheme__active___2kAKB {
    color: var(--_apc-sidebar-text-primary, var(--primary));
    font-weight: 600;
  }

.DefaultTheme__anchor___1Xu1v.DefaultTheme__active___2kAKB {
    cursor: default;
  }

.DefaultTheme__anchor___1Xu1v:focus {
    outline: none;
  }

.DefaultTheme__anchor___1Xu1v:hover::before,
  .DefaultTheme__anchor___1Xu1v:focus::before,
  .DefaultTheme__anchor___1Xu1v:active::before,
  .DefaultTheme__anchor___1Xu1v.DefaultTheme__active___2kAKB::before {
    opacity: 1;
    transform: translateX(0);
  }

.DefaultTheme__anchor___1Xu1v:active::before,
  .DefaultTheme__anchor___1Xu1v.DefaultTheme__active___2kAKB::before {
    background: var(--_apc-sidebar-text-primary, var(--core-blue3));
  }

.DefaultTheme__anchor___1Xu1v::before {
    --_apc-sidebar-link-before-border-radius: var(--_apc-sidebar-link-before-border-radius-lume, none);

    border-radius: var(--_apc-sidebar-link-before-border-radius);
    background: var(--_apc-sidebar-text-color, var(--core-blue3));
    content: '';
    display: block;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transform: translateX(-3px);
    transition: opacity .15s cubic-bezier(.46,.03,.52,.96), transform .15s cubic-bezier(.46,.03,.52,.96);
    width: 3px;
  }
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/platform-components/SidebarLink/themes/DefaultTheme.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8EAA8E;;EAE9E,mBAAmB;EACnB,oDAAoD;EACpD,eAAe;EACf,aAAa;EACb,4DAA4D;UACpD,oDAAoD;AAC9D;;AAEA;IACI,iFAAiF;;IAEjF,kDAAkD;EACpD;;AAEF;;IAEI,uDAAuD;IACvD,gBAAgB;EAClB;;AAEF;IACI,eAAe;EACjB;;AAEF;IACI,aAAa;EACf;;AAEF;;;;IAII,UAAU;IACV,wBAAwB;EAC1B;;AAEF;;IAEI,+DAA+D;EACjE;;AAEF;IACI,kGAAkG;;IAElG,4DAA4D;IAC5D,6DAA6D;IAC7D,WAAW;IACX,cAAc;IACd,YAAY;IACZ,OAAO;IACP,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,2BAA2B;IAC3B,oGAAoG;IACpG,UAAU;EACZ","sourcesContent":[".DefaultTheme__sidebar-link___2j3Ea {\n  list-style-type: none;\n  margin: 10px 0;\n  padding: 0 20px;\n  position: relative;\n}\n\n.DefaultTheme__icon___3DO_l {\n  fill: currentColor;\n  margin-right: 5px;\n}\n\n.DefaultTheme__anchor___1Xu1v {\n  --_apc-sidebar-text-decoration: var(--_apc-sidebar-text-decoration-lume, none);\n\n  align-items: center;\n  color: var(--_apc-sidebar-text-color, var(--steel4));\n  cursor: pointer;\n  display: flex;\n  -webkit-text-decoration: var(--_apc-sidebar-text-decoration);\n          text-decoration: var(--_apc-sidebar-text-decoration);\n}\n\n.DefaultTheme__anchor___1Xu1v:hover {\n    --_apc-sidebar-hover-font-weight: var(--_apc-sidebar-hover-font-weight-lume, 400);\n\n    font-weight: var(--_apc-sidebar-hover-font-weight);\n  }\n\n.DefaultTheme__anchor___1Xu1v:active,\n  .DefaultTheme__anchor___1Xu1v.DefaultTheme__active___2kAKB {\n    color: var(--_apc-sidebar-text-primary, var(--primary));\n    font-weight: 600;\n  }\n\n.DefaultTheme__anchor___1Xu1v.DefaultTheme__active___2kAKB {\n    cursor: default;\n  }\n\n.DefaultTheme__anchor___1Xu1v:focus {\n    outline: none;\n  }\n\n.DefaultTheme__anchor___1Xu1v:hover::before,\n  .DefaultTheme__anchor___1Xu1v:focus::before,\n  .DefaultTheme__anchor___1Xu1v:active::before,\n  .DefaultTheme__anchor___1Xu1v.DefaultTheme__active___2kAKB::before {\n    opacity: 1;\n    transform: translateX(0);\n  }\n\n.DefaultTheme__anchor___1Xu1v:active::before,\n  .DefaultTheme__anchor___1Xu1v.DefaultTheme__active___2kAKB::before {\n    background: var(--_apc-sidebar-text-primary, var(--core-blue3));\n  }\n\n.DefaultTheme__anchor___1Xu1v::before {\n    --_apc-sidebar-link-before-border-radius: var(--_apc-sidebar-link-before-border-radius-lume, none);\n\n    border-radius: var(--_apc-sidebar-link-before-border-radius);\n    background: var(--_apc-sidebar-text-color, var(--core-blue3));\n    content: '';\n    display: block;\n    height: 100%;\n    left: 0;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    transform: translateX(-3px);\n    transition: opacity .15s cubic-bezier(.46,.03,.52,.96), transform .15s cubic-bezier(.46,.03,.52,.96);\n    width: 3px;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
